import { Container } from 'pixi.js';

export abstract class Scene {
  readonly container: Container;

  constructor() {
    this.container = new Container();
  }

  abstract enter(context?: unknown): void;
  abstract update(deltaTime: number): void;
  abstract exit(): void;
}
